function stripBracketUserAgent(userAgent = "") {
  return userAgent.replace(/\[(.*)\]/g, "");
}
function getUserAgentString(userAgent) {
  let ua;
  if (typeof window === "undefined" && !userAgent) {
    ua = "Mozilla/5.0 (Linux; Android 10; Pixel 4 XL Build/QQ3A.200605.001; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/84.0.4147.89 Mobile Safari/537.36;KAKAOTALK 2108960; KT/8.9.6 An/10 (ko) PAY/WEB";
  } else {
    ua = userAgent || window.navigator.userAgent || window.navigator.vendor;
  }
  return stripBracketUserAgent(ua);
}
export {
  getUserAgentString,
  stripBracketUserAgent
};
